export default __webpack_public_path__ + "static/media/chatbot_icon.45dde427.svg";